<template>
  <v-app>
    <div class="grey lighten-2">
      <router-view> </router-view>
    </div>
  </v-app>
</template>

<script>
import UM from "@/api/user-management";
import TM from "@/api/ticket-management";

export default {
  name: "App",
  metaInfo() {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'Ticket Plus遠大售票系統',
      // all titles will be injected into this template
    };
  },
  async mounted() {
    let msScript = document.createElement("script");
    msScript.setAttribute("type", "text/javascript");
    msScript.setAttribute("language", "javascript");
    msScript.innerHTML = `(function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", "${process.env.VUE_APP_CLARITY_KEY}");`;
    document.head.appendChild(msScript);
    // 重新取得登入資訊
    // this.$store.dispatch("user/getInfo");
    const userInfo = JSON.parse(Cookies.get("user") || null) || {};
    window.clarity("identify", userInfo.id)

    if (!!window.localStorage.getItem('needReleaseOrder')) {
      const { data } = await TM.ticketRelease({
        orderId: Number(window.localStorage.getItem('needReleaseOrder'))
      });
      console.log(`${String.fromCodePoint(128049)} [TM] release`, data);
      window.localStorage.removeItem('needReleaseOrder')
    }
  },
};
</script>

<style lang="scss">
// Import Main styles for this application
@import "assets/scss/style";

.v-main {
  z-index: 1;
}

.v-overlay--active {
  backdrop-filter: blur(5px);
}

.v-overlay__scrim {
  backdrop-filter: blur(5px);
}

.red-dash-divider {
  opacity: 0.7;
  border-top: 1px dashed $primary;
}

.cursor-pointer {
  cursor: pointer;
}

.v-tooltip__content {
  background-color: #444;
}

body {
  font-family: "Noto Sans TC", -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif,
    "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji",
    "Microsoft JhengHei", sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.4;
}

h1,
.text-massive-title {
  font-size: 36px;
  font-weight: bold;
  line-height: 1.4;
}

h2,
.text-huge-title {
  font-size: 28px;
  font-weight: bold;
  line-height: 1.5;
}

h3,
.text-big-title {
  font-size: 24px;
  font-weight: bold;
  line-height: 1.5;
}

.text-page-title,
h4 {
  font-size: 20px;
  font-weight: bold;
  line-height: 1.5;
}

.text-title,
h5 {
  font-size: 18px !important;
  font-weight: 500;
  line-height: 1.4;
}

.font-weight-regular {
  font-weight: 400 !important;
}

.text-regular,
.text-regular * {
  font-size: 16px;
  font-weight: 400;
  line-height: 1.4;
}

.text-nine,
.text-eight,
.text-small,
.caption,
.text-small *,
.caption * {
  font-size: 14px !important;
}

.caption * {
  line-height: 2;
}

.text-seven,
.v-messages .v-messages__wrapper .v-messages__message,
.text-mini,
small {
  font-size: 12px !important;
}

@media screen and (max-width: 599px) {
  .text-xs-massive-title {
    font-size: 36px !important;
    font-weight: bold;
    line-height: 1.4;
  }

  .text-xs-huge-title {
    font-size: 28px;
    font-weight: bold;
    line-height: 1.5;
  }

  .text-xs-big-title {
    font-size: 24px;
    font-weight: bold;
    line-height: 1.5;
  }

  .text-xs-page-title {
    font-size: 20px;
    font-weight: bold;
    line-height: 1.5;
  }

  .text-xs-title {
    font-size: 18px !important;
    font-weight: 500;
    line-height: 1.4;
  }

  .text-xs-regular,
  .text-xs-regular * {
    font-size: 16px;
    font-weight: 400;
    line-height: 1.4;
  }
}

@media screen and (min-width: 600px) {
  .text-sm-massive-title {
    font-size: 36px !important;
    font-weight: bold;
    line-height: 1.4;
  }

  .text-sm-huge-title {
    font-size: 28px;
    font-weight: bold;
    line-height: 1.5;
  }

  .text-sm-big-title {
    font-size: 24px;
    font-weight: bold;
    line-height: 1.5;
  }

  .text-sm-page-title {
    font-size: 20px !important;
    font-weight: bold;
    line-height: 1.5;
  }

  .text-sm-title {
    font-size: 18px !important;
    font-weight: 500;
    line-height: 1.4;
  }

  .text-sm-regular,
  .text-sm-regular * {
    font-size: 16px;
    font-weight: 400;
    line-height: 1.4;
  }
}

@media screen and (min-width: 960px) {
  .text-md-massive-title {
    font-size: 36px !important;
    font-weight: bold;
    line-height: 1.4;
  }

  .text-md-huge-title {
    font-size: 28px;
    font-weight: bold;
    line-height: 1.5;
  }

  .text-md-big-title {
    font-size: 24px;
    font-weight: bold;
    line-height: 1.5;
  }

  .text-md-page-title {
    font-size: 20px;
    font-weight: bold;
    line-height: 1.5;
  }

  .text-md-title {
    font-size: 18px !important;
    font-weight: 500;
    line-height: 1.4;
  }

  .text-md-regular,
  .text-md-regular * {
    font-size: 16px;
    font-weight: 400;
    line-height: 1.4;
  }
}

a,
a:link,
[role="button"],
.v-btn .v-btn__content {
  font-weight: 500;
  line-height: 1;
}

.v-btn.v-size--small .v-btn__content {
  font-weight: 500;
  font-size: 14px;
  line-height: 1;
}

@media screen and (min-width: 600px) {

  .text-sm-regular,
  .text-sm-regular * {
    font-size: 16px !important;
    font-weight: 400;
    line-height: 1.4;
  }

  .text-sm-small,
  .text-sm-small * {
    font-size: 14px !important;
  }
}

.row {
  margin-left: -12px;
  margin-right: -12px;
  margin-top: 0px;
  margin-bottom: 0px;

  .col {
    padding-top: 0;
    padding-bottom: 0;
  }
}

.no-decoration:link {
  text-decoration: none;
}

.v-card.v-card--link {
  border-radius: 8px !important;
  box-shadow: 0 8px 0px 0 rgba(0, 0, 0, 0) !important;
  border: 2px solid $grey-lighten-1;
  transition: all 0.3s ease;

  &:hover,
  &:focus {
    border: 2px solid transparent;
    box-shadow: 0 8px 20px 0 rgba(0, 0, 0, 0.15) !important;
  }
}

.is-word-break {
  word-break: break-all;
}

// Verticle Align
.valign-top {
  vertical-align: top !important;
}

.valign-middle {
  vertical-align: middle !important;
}

.valign-bottom {
  vertical-align: bottom !important;
}

.v-card {
  border-radius: 20px;
  box-shadow: $shadow !important;
}

.page-header.elevation-1 {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1) !important;
}

@media screen and (max-width: 600px) {
  .v-card {
    border-radius: 8px;
  }
}

@media only screen and (min-width: 600px) and (max-width: 960px) {
  .v-card {
    border-radius: 12px;
  }
}

.bg-tranparent-yellow {
  background-color: $opacityYellow !important;
}

.rounded-1 {
  border-radius: 4px;
}

.rounded-2 {
  border-radius: 8px;
}

.rounded-3 {
  border-radius: 12px;
}

.rounded-4 {
  border-radius: 16px;
}

.rounded-5 {
  border-radius: 20px;
}

.rounded-6 {
  border-radius: 24px;
}

.height90 {
  height: 90% !important;
}

body {
  .v-tab {
    font-size: $font-size-root;
  }

  &.dialog-open main.v-main {
    z-index: 6 !important;
  }

  .v-application {
    .v-application .primary-1--text {
      color: $primary-1 !important;
      caret-color: $primary-1 !important;
    }

    a,
    a:link {
      color: $accent-blue;
    }

    .v-btn.v-btn--rounded,
    .v-btn.v-btn--rounded::after {
      border-radius: 50px !important;
    }

    .v-btn.v-btn--outlined:not(.v-btn--disabled) {
      position: relative;
      background-color: $primary-dark;
      background: $gradient;
      padding: 12px 32px;
      border: 0 !important;
      z-index: 0;

      &::before {
        z-index: 1;
      }

      &::after {
        content: "";
        position: absolute;
        width: calc(100% - 4px);
        height: calc(100% - 4px);
        background-color: white;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        z-index: 0;
      }

      .v-btn__content {
        font-size: 14px;
        line-height: 1;
        color: $primary-dark !important;
        font-weight: 500;
        z-index: 1;
      }

      &.v-size--x-large .v-btn__content {
        font-size: 16px;
      }
    }

    .nextBtn {
      font-weight: 600;
      background-image: $gradient !important;
      color: white !important;

      .v-btn__content {
        font-size: 14px;
        line-height: 1;
        font-weight: 500;
      }

      &.disabledBtn {
        background: $grey-lighten-1 !important;
        color: $grey-1 !important;
      }

      &.v-size--x-large .v-btn__content {
        font-size: 16px;
      }
    }
  }

  .vue-phone-number-input.lg {
    .country-selector__list {
      top: calc(100% + 8px);

      .vue-recycle-scroller__item-wrapper .vue-recycle-scroller__item-view .country-selector__list__item {
        &:hover {
          background: $grey-lighten-2 !important;
        }

        &.selected {
          background: $primary-dark !important;
        }
      }
    }

    .select-country-container+.flex-1 {
      margin-left: 12px;
    }

    .country-selector .country-selector__label,
    .input-tel.input-phone-number .input-tel__label {
      font-size: 11px;
      color: #737373 !important;
      z-index: 9;
      border-radius: 4px !important;
    }

    .country-selector.lg {
      .country-selector__country-flag {
        top: 24px;
      }

      .country-selector__input {
        padding-top: 4px;
        height: 56px;
        font-size: 16px;
      }
    }

    .country-selector.is-focused .country-selector__label,
    .input-tel.input-phone-number.is-focused .input-tel__label {
      color: #379cc4 !important;
      border-radius: 4px !important;
      z-index: 9;
    }

    .country-selector:not(.is-focused):not(.has-error) .country-selector__input,
    .input-tel.input-phone-number:not(.is-focused):not(.has-error) .input-tel__input {
      border-color: #9e9e9e !important;
      border-radius: 4px !important;
    }

    .country-selector:not(.is-focused):not(.has-error):hover .country-selector__input,
    .input-tel.input-phone-number:not(.is-focused):not(.has-error):hover .input-tel__input {
      border-color: #222222 !important;
      border-radius: 4px !important;
    }

    .input-tel.input-phone-number .input-tel__label {
      background: white;
    }

    .country-selector.has-value .country-selector__label,
    .input-tel.input-phone-number.has-value .input-tel__label {
      top: 0;
      margin-top: -6px;
      padding: 0 2px;
      background: white;
    }

    .country-selector.input-country-selector .country-selector__input,
    .input-tel.input-phone-number .input-tel__input {
      box-shadow: none !important;
    }

    .input-tel.input-phone-number {
      .input-tel__input {
        padding-top: 6px;
        height: 56px;
        font-size: 16px;
      }

      &.has-error>.input-tel__input,
      &.is-focused>.input-tel__input {
        border-width: 2px;
        z-index: 9;
      }

      &.is-focused>.input-tel__input {
        border-color: #379cc4 !important;
        border-radius: 4px !important;
      }
    }

    .country-selector.input-country-selector {

      &.has-error>.country-selector__input,
      &.is-focused>.country-selector__input {
        border-width: 2px;
        z-index: 9;
      }

      &.is-focused>.country-selector__input {
        border-color: #379cc4 !important;
        border-radius: 4px !important;
      }
    }

    .input-tel.input-phone-number.has-error>.input-tel__input,
    .input-tel.input-phone-number.is-focused>.input-tel__input {
      border-radius: 4px !important;
    }

    // // 電話號碼輸入視窗的高度
    // .input-tel.lg {
    //   height: 56px;
    // }
    // .input-tel.lg .input-tel__input {
    //   font-size: 16px;
    //   height: 56px;
    // }

    // // 國碼選擇視窗的高度
    // .country-selector.lg {
    //   height: 56px;
    // }
    // .country-selector.lg .country-selector__input {
    //   height: 56px;
    // }

    // // 國旗位置
    // .country-selector.lg .country-selector__country-flag {
    //   margin-top: 5px;
    // }

    // // 區域字串與位置
    // label {
    //   font-size: 14px;
    // }
    // label.country-selector__label {
    //   margin-top: 5px;
    // }

    // // 手機號碼輸入視窗的 hint 位置
    // label.input-tel__label {
    //   margin-top: 5px;
    // }

    // // 國碼與手機號碼的 input
    // input {
    //   font-size: 16px;
    // }
  }
}
</style>
